import { render, staticRenderFns } from "./modalDetailBRS.vue?vue&type=template&id=6483408b"
import script from "./modalDetailBRS.vue?vue&type=script&lang=js"
export * from "./modalDetailBRS.vue?vue&type=script&lang=js"
import style0 from "./modalDetailBRS.vue?vue&type=style&index=0&id=6483408b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports